import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';


const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [redirectToHome, setRedirectToHome] = useState(false);
  const [error, setError] = useState('')
  const navigate = useNavigate();

  useEffect(() => {
    if (redirectToHome) {
      navigate('/');
    }
  }, [redirectToHome, navigate]);

  const handleChange = (e) => {
    if (e.target.name === 'email') {
      setEmail(e.target.value);
    } else if (e.target.name === 'password') {
      setPassword(e.target.value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userForm = {
        email: email,
        password: password,
      };
  
      const response = await axios.post(`${process.env.REACT_APP_API}/connexion`,
       userForm);

  
      if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
        
      
        toast.success('Connexion réussie !');
  
        if (!error) {
          navigate('/');
        }
      }
    } catch (error) {
  toast.error(error.response?.data?.message || "Une erreur est produite lors de la tentative de connexion.")
  
    }
  };
  return (
    <main>
    <section className="form-container">
      <form method="post" onSubmit={handleSubmit}>
        <h3>Connectez-vous maintenant</h3>
        <p>Votre email <strong>*</strong></p>
        <input
          type='email'
          placeholder="Entrez votre email"
          required
          maxLength="50"
          className="box"
          name='email'
          onChange={handleChange}
        />
        <p htmlFor="password">Votre mot de passe <strong>*</strong></p>
        <input
          maxLength="20"
          className="box"
          type='password'
          placeholder="Entrez votre mot de passe"
          required
          name='password'
          onChange={handleChange}
        />
        <input type="submit" value="Se connecter" name="submit" className="btn" />
      </form>
      <p className='sign-up'>
        Vous n'êtes pas inscrit? <Link to='/inscription'>Inscrivez-vous ici</Link>
      </p>
    </section>
  </main>

  );
};

export default Login;
